import _ from "lodash";
import { getIn } from "formik";
import PropTypes from "prop-types";
import React from "react";

import { cn } from "@/lib/helpers/cn";

import { FormFieldError } from "../FormFieldError/FormFieldError";
import { TextArea } from "../../TextArea";

import "../styles.scss";
import "./styles.scss";

export const FormTextArea = ({
  className,
  customError,
  formikProps,
  inputClassName,
  name,
  // a callback called each time a field changes
  // NOTE: the risk with using this is the unknown in the order
  // the formik form re-renders. If an update is made via the handleChange
  // function which triggers another form update via the onChangeCallBack,
  // logically one would think that the initial field updates could appear
  // before the onChangeCallback updates complete which would render an invalid state.
  // In practice the formik forms look to re-render very fast so this should not be a
  // problem, this is just something to watch out for
  onChangeCallBack,
  placeholder,
  readOnly,
  resize,
  subTitle,
  testId,
  title,
  // normally form fields do not error until after submission
  // because they have not been touched
  // setting this to true triggers the error after editing
  // for the first time
  triggerErrorOnChange = false,
}) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const value = _.get(formikProps.values, name);

  const handleChange = async (event) => {
    const value = event.target.value;

    await formikProps.setFieldValue(name, value);
    if (!isTouched && triggerErrorOnChange) {
      await formikProps.setFieldTouched(name, true);
    }
    if (onChangeCallBack) {
      await onChangeCallBack(name, value);
    }
  };

  return (
    <div className={cn("FormField-container", className)} {...{ inert: readOnly ? "" : undefined }}>
      {title && (
        <strong className="FormField-title" data-public>
          {title}
        </strong>
      )}

      {subTitle && (
        <small className="FormField-subTitle" data-public>
          {subTitle}
        </small>
      )}

      <TextArea
        className={cn("FormTextArea-input", inputClassName)}
        error={isTouched && errorMessage}
        ignoreEnterSubmit={true}
        name={name}
        onChange={handleChange}
        placeholder={placeholder}
        readOnly={readOnly}
        resize={resize}
        testId={testId}
        value={value}
      />

      {!customError && errorMessage && isTouched && <FormFieldError>{errorMessage}</FormFieldError>}

      {/* lets the dev pick what is displayed below the text area */}
      {customError && customError(value, errorMessage, isTouched)}
    </div>
  );
};

FormTextArea.propTypes = {
  className: PropTypes.string,
  customError: PropTypes.func,
  formikProps: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  subTitle: PropTypes.string,
  testId: PropTypes.string,
  title: PropTypes.string,
};
